import { render, staticRenderFns } from "./ChatButton.vue?vue&type=template&id=bd5feb12&scoped=true&"
import script from "./ChatButton.vue?vue&type=script&lang=js&"
export * from "./ChatButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatButton.vue?vue&type=style&index=0&id=bd5feb12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5feb12",
  null
  
)

export default component.exports